import { defineComponent, h } from 'vue';
import { QBanner, QIcon } from 'quasar';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';

import TranslationContainer from '../TranslationContainer.jsx';

export default defineComponent({
    name: 'sform-help',
    mixins: [BaseComponent],
    components: {
        QBanner,
        QIcon,
        TranslationContainer,
    },
    data: () => ({
        titleexpr: null,
        bodyexpr: null,
        colorexpr: null,
    }),
    props: {
    },
    created() {
        // if (this.element.title)
        //     this.titleexpr = utils.compile(this, this.Translate(this.element.title));

        // if (this.element.body)
        //     this.bodyexpr = utils.compile(this, this.Translate(this.element.body));
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
        title() {
            if(this.element.title)
                return <TranslationContainer context={this} value={this.element.title}></TranslationContainer>;
            else if (this.element.titleExpression) {
                if (!this.titleexpr)
                    this.titleexpr = utils.compileExpression(this, this.element.titleExpression);

                return utils.evaluate(this.titleexpr, this);
            }

            return null;
        },
        body() {
            if (this.element.body)
                return <TranslationContainer context={this} value={this.element.body} isPossibleHtml={true}></TranslationContainer>;
            else if (this.element.bodyExpression) {
                if (!this.bodyexpr)
                    this.bodyexpr = utils.compileExpression(this, this.element.bodyExpression);

                return utils.evaluate(this.bodyexpr, this);
            }

            return null;
        },
        color() {
            if (this.element.color)
                return this.element.color;
            else if (this.element.colorExpression) {
                if (!this.colorexpr)
                    this.colorexpr = utils.compileExpression(this, this.element.colorExpression);

                return utils.evaluate(this.colorexpr, this);
            }

            return null;
        },
    },
    methods: {
    },
    render() {
        let type = this.color; 
        let iconName = '';
        let bgColor = '';
        let textColor = '';

        if (type === 'warning') {
            bgColor = 'color-mix(in srgb, var(--v-outbound-base) 12%, transparent)';
            textColor = 'var(--v-outbound-base)';       
            iconName = 'mdi-alert';
        } 
        else if (typeof type === 'string' && type.startsWith('mdi')) {     
            bgColor = 'var(--v-activeBackground-base, #eef0ff)';
            textColor = 'var(--v-primary-base)';
            iconName = type.replace(/^\s*mdi\s+/, 'mdi-').trim() || 'mdi-information';
        } 
        else {
            bgColor = 'var(--v-activeBackground-base, #eef0ff)';
            textColor = 'var(--v-primary-base)';
            iconName = 'mdi-information';
        }

        let title;
        let body;

        const contentStyle = { 
            padding: '8px 0', 
            whiteSpace: 'normal', 
            wordBreak: 'break-word' 
        };

        if (this.title && this.body) {
            title = <div class="text-subtitle1" style={{ padding: 0 }}>{this.title}</div>;
            body = <div style={{ padding: 0 }}>{this.body}</div>;
        } else if (this.title) {
            title = <div style={{ padding: 0 }}>{this.title}</div>;
        } else if (this.body) {
            body = <div style={{ padding: 0 }}>{this.body}</div>;
        }

        const bannerClass = ['q-mb-sm', 'c-formHelp', 'rounded-borders'];
        const bannerStyle = {};

        if (bgColor) bannerStyle.backgroundColor = bgColor;
        if (textColor) bannerStyle.color = textColor;

        return (
            <QBanner
                class={bannerClass.join(' ')}
                style={bannerStyle}
                v-slots={{
                    avatar: () => <QIcon name={iconName} size="sm" />,
                }}
            >
                <div style={contentStyle}>
                    {title}
                    {body}
                </div>
            </QBanner>
        );
    }
});